import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class InvestmentApproachConfiguration extends ReportSectionConfigurationBase {
  typeName = 'InvestmentApproachConfiguration';
  readonly reportSection = ReportSection.InstitutionInvestmentApproach;
  name = 'investmentApproach';
  displayName = 'Investment Approach';
  applicableReportTypes: ReportType[] = [ReportType.Contact, ReportType.Institution];
  minSize = 1;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections = [
    {
      name: 'investmentApproach',
      displayName: 'Investment Approach',
      isSelected: true,
      canConfigure: true
    }
  ];
  override additionalConfiguration: AdditionalConfiguration = {
    isTruncated: false,
    truncationLength: 5
  };
  override readonly configurationControls = [
    {
      name: 'investmentApproachTruncation',
      displayName: 'Truncation',
      type: 'truncation',
      applicableDataSection: 'investmentApproach',
      defaultLength: 700
    }
  ];

  get nodataLocalizationKeyName(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'primaryInstitutionInvestmentApproach';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'investmentApproach';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get reportViewModelSections(): ReportViewModelSection[] {
    if (this.appliedReportType === ReportType.Contact) {
      return [ReportViewModelSection.InvestorProfile_PrimaryInstitutionInvestmentApproach];
    } else if (this.appliedReportType === ReportType.Institution) {
      return [ReportViewModelSection.InvestorProfile_InstitutionInvestmentApproach];
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface InvestmentApproachData {
  [ReportViewModelSection.InvestorProfile_PrimaryInstitutionInvestmentApproach]: {
    overview: string;
  };
  [ReportViewModelSection.InvestorProfile_InstitutionInvestmentApproach]: {
    overview: string;
  };
}
